import { AlertCircle, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function PanelError({
  onRetry,
  message = "Couldn't load data",
  detail,
}: {
  onRetry: () => void
  message?: string
  detail?: string
}) {
  return (
    <div
      data-testid="panel-error"
      className="flex h-full flex-col items-center justify-center gap-2 px-4 text-center text-xs text-muted-foreground"
    >
      <AlertCircle className="size-5 text-muted-foreground/70" />
      <div className="font-medium text-foreground/80">{message}</div>
      {detail ? <div className="max-w-xs text-muted-foreground/70">{detail}</div> : null}
      <Button variant="outline" size="sm" onClick={onRetry} className="mt-1">
        <RefreshCw className="size-3.5" />
        Retry
      </Button>
    </div>
  )
}
